import { configStore, documentStore } from "@/store/store";
import { Control } from "@/types/controls";
import { BuilderElement } from "@/types/elements";
import { getControlAtPath } from "@/lib/controls/should-show-control";
import { getBreakdanceBlockPostType } from "../constants/post-types";

export function isOpenDocumentAComponent() {
  return (
    documentStore.document.documentMeta.postType ===
      getBreakdanceBlockPostType() && configStore.builderMode === "oxygen"
  );
}

export function isControlAllowedAsEditablePropertyInComponent(
  controlPath: string
) {
  const segments = controlPath.split(".").slice(0, -1);
  const isInsideRepeater = segments.some(segment => /\[\d+]$/.test(segment));
  return controlPath.startsWith("content.") && !isInsideRepeater;
}

export function getControlAtPath2(
  controlPath: string,
  controls: BuilderElement["controls"]
) {
  return getControlAtPath(
    removePrefixFromControlPath(controlPath),
    // @ts-ignore
    controls[`${getPrefixFromControlPath(controlPath)}Sections`] as Control[]
  );
}

function getPrefixFromControlPath(controlPath: string) {
  const pathParts = controlPath.split(".");
  return pathParts[0];
}

function removePrefixFromControlPath(controlPath: string) {
  const pathParts = controlPath.split(".");
  pathParts.splice(0, 1);
  return pathParts.join(".");
}

export function removeConditionsFromControls(controls: Control[]) {
  return controls.map(control => {
    return {
      ...control,
      options: {
        ...control.options,
        condition: undefined
      }
    };
  });
}
